var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.962,
    height: 16.392,
    viewBox: "0 0 15.962 16.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0422\\u0440\\u0443\\u0431\\u043A\\u0430",
    transform: "translate(-4.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M171.067,45.875a4.956,4.956,0,0,0-4.388-4.723c-.049-.006-.1-.015-.157-.024a2.281,2.281,0,0,0-.372-.041.624.624,0,0,0-.669.561.648.648,0,0,0,.1.508.96.96,0,0,0,.691.3c.069.009.133.018.187.03,2.191.49,2.929,1.26,3.29,3.432.009.053.013.119.017.188.016.26.049.8.629.8h0a1.031,1.031,0,0,0,.154-.012c.541-.082.524-.576.516-.813a1.2,1.2,0,0,1,0-.172A.228.228,0,0,0,171.067,45.875Z",
    transform: "translate(-153.041 -38.996)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    d: "M161.235,1.308c.065,0,.126.009.178.017,3.6.553,5.253,2.258,5.712,5.885a2.116,2.116,0,0,1,.01.216c0,.283.014.873.647.885h.02a.621.621,0,0,0,.469-.178.991.991,0,0,0,.172-.758c0-.06-.005-.117,0-.167a7.334,7.334,0,0,0-6.871-7.2.257.257,0,0,0-.045,0,.31.31,0,0,1-.044,0c-.037,0-.082,0-.131-.006S161.224,0,161.158,0a.651.651,0,0,0-.717.67C160.408,1.247,160.967,1.288,161.235,1.308Z",
    transform: "translate(-148.268)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    d: "M18.684,27.107c-.077-.058-.156-.119-.23-.179-.393-.316-.811-.608-1.215-.889l-.251-.176a2.509,2.509,0,0,0-1.423-.54,1.844,1.844,0,0,0-1.535.973.816.816,0,0,1-.7.425,1.391,1.391,0,0,1-.564-.142,6.789,6.789,0,0,1-3.547-3.454c-.33-.741-.223-1.226.358-1.62a1.64,1.64,0,0,0,.9-1.438,8.213,8.213,0,0,0-2.89-3.942,1.641,1.641,0,0,0-1.116,0,3.229,3.229,0,0,0-2.01,1.653,3.073,3.073,0,0,0,.044,2.48,20.008,20.008,0,0,0,4.39,6.684,21.282,21.282,0,0,0,6.661,4.423,3.689,3.689,0,0,0,.659.2c.061.014.114.025.152.036a.256.256,0,0,0,.065.009h.021a3.778,3.778,0,0,0,3.138-2.388C19.983,28.1,19.262,27.549,18.684,27.107Z",
    transform: "translate(0 -15.21)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M170.939,83.556a.758.758,0,0,0-.8.459.615.615,0,0,0,.025.534.8.8,0,0,0,.6.319,1.427,1.427,0,0,1,1.324,1.425.675.675,0,0,0,.642.666h0a.634.634,0,0,0,.076,0c.408-.049.605-.348.588-.89a2.543,2.543,0,0,0-.793-1.72A2.367,2.367,0,0,0,170.939,83.556Z",
    transform: "translate(-157.431 -79.302)",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.dda6e9f1f41d6ee31ab5db2f16413ecb.svg";
export { ForwardRef as ReactComponent };